import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
import { Link } from "react-router-dom";

// Set the accommodation booking survey URL when available (Tencent questionnaire).
const ACCOMMODATION_SURVEY_URL = "https://wj.qq.com/s2/27027659/47d3/";
const ACCOMMODATION_FORM_XLSX = `${process.env.PUBLIC_URL}/accommodation/accommodation_form.xlsx`;

const AccommodationBook = () => {
  return (
    <React.Fragment>
      <SEO title="Accommodation Booking | ICSI 2026" />
      <Header />
      <Breadcrumb
        image="images/banner/banner.jpg"
        title="Accommodation Booking"
        content="For Participants"
        contentTwo="Accommodation Booking"
        linkage="/accommodation"
      />

      <EmptyTwo>
        <div className="entry-header accommodation-book-page">
          <div className="accommodation-survey-fallback">
            <p>
              If the online survey is not accessible in your region, you may{" "}
              <a href={ACCOMMODATION_FORM_XLSX} download>
                download this Excel form
              </a>
              , fill it in, and email it to{" "}
              <a href="mailto:icsi2026@iasei.org">icsi2026@iasei.org</a>.
            </p>
          </div>
          {ACCOMMODATION_SURVEY_URL ? (
            <div className="reg-form">
              <iframe
                src={ACCOMMODATION_SURVEY_URL}
                title="ICSI 2026 Accommodation Booking Survey"
              />
            </div>
          ) : (
            <div className="accommodation-survey-placeholder">
              <p>The accommodation booking survey will be available here shortly.</p>
            </div>
          )}
          <div className="back">
            <Link
              className="btn btn-primary btn-hover-secondary mt-s"
              to={process.env.PUBLIC_URL + "/accommodation"}
            >
              Back to Accommodation page
            </Link>
          </div>
        </div>
      </EmptyTwo>

      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default AccommodationBook;
